import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import StickyMobileBar from "@/components/StickyMobileBar";
import api from "@/lib/api";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/articles/${slug}`).then(r=>{ setA(r.data); document.title = `${r.data.title} | Nexus Legal`; }).catch(()=>setErr(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <Nav />
      <article className="pt-40 md:pt-56 pb-24 px-6 md:px-24 max-w-[1000px] mx-auto">
        <Link to="/insights" className="inline-flex items-center gap-2 text-white/50 hover:text-[#C8A45D] transition-colors font-cinzel text-[10px] tracking-[0.3em] mb-12" data-testid="back-to-insights"><ArrowLeft size={14}/> BACK TO INSIGHTS</Link>
        {err && <div className="text-white/60 font-serif-display text-3xl">Article not found.</div>}
        {a && (
          <>
            <div className="flex gap-4 items-center mb-8 text-[10px] font-cinzel tracking-[0.3em]">
              <span className="text-[#C8A45D]">{a.category}</span>
              <span className="text-white/40">{a.reading_time}</span>
              <span className="text-white/30">{new Date(a.created_at).toLocaleDateString(undefined,{year:"numeric", month:"short", day:"numeric"})}</span>
            </div>
            <h1 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-white mb-8">{a.title}</h1>
            <div className="hairline w-24 mb-12"/>
            {a.thumbnail && <div className="mb-12 aspect-[16/9] overflow-hidden"><img src={a.thumbnail} alt={a.title} className="w-full h-full object-cover grayscale"/></div>}
            <div className="prose prose-invert max-w-none font-body text-white/75 text-lg leading-relaxed whitespace-pre-line">{a.content || a.excerpt}</div>
          </>
        )}
      </article>
      <Footer />
      <StickyMobileBar />
    </div>
  );
}
